var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"adminLayout"},[_c('Alerts',{attrs:{"success":_vm.isSuccess,"error":_vm.error}}),_c('div',{staticClass:"container mx-auto px-4 lg:px-4 bg-white rounded-lg"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }